const my_profile = {
  viewMyClubSeacretProfile: "私のClubSecretプロフィールを見る", // translated
  viewMoreDetails: "詳細を見る", // translated
  verifiedEmail: "確認済みメールアドレス", // translated
  unverifiedEmail: "未確認のメール", // translated
  pointsOut: "指摘している", // translated
  pointsIn: "ポイントイン", // translated
  balance: "バランス", // translated
  pointsHistoryTable: "ポイント履歴テーブル", // translated
  topUp: "補充する", // translated
  createdFrom: "作成日（開始）", // translated
  createdTo: "作成日（終了）", // translated
  selectStatus: "ステータスを選択...", // translated
  searchByTitle: "タイトルで検索...", // translated
  offerStatus: "オファーステータス", // translated
  selectOfferStatus: "すべて", // translated
  quotationSent: "見積もり送信済み", // translated
  offerInProgress: "オファー進行中", // translated
  offerAvailable: "オファー利用可能", // translated
  offerAccepted: "オファー承認済み", // translated
  offerExpired: "オファー期限切れ", // translated
  pushNotifications: "プッシュ通知", // translated 
  pushNotificationsDescription: "重要更新やイベントのブラウザ通知を受信", // translated 
  pushNotificationsNotSupported: "このブラウザではプッシュ通知がサポートされていません", // translated 
  pushNotificationsDeniedMessage: "通知の許可が拒否されました。選択通知を受信するには、ブラウザの設定で通知を有効にしてください。", // translated 
  pushNotificationsEnabled: "命令通知が正常に有効化されました", // translated 
  pushNotificationsDisabled: "命令通知が正常に無効化されました", // translated 
  userInformationMissing: "ユーザー情報が不足しています", // translated 
  failedToUpdatePushNotifications: "異議通知設定の更新に失敗しました", // translated 
  notificationPermissionDenied: "通知の許可が拒否されました。ブラウザの設定で有効にしてください。", // translated 
  notificationPermissionRequired: "プッシュ通知を有効にするためには通知の許可が必要です", // translated 
  notSupported: "サポートされていない", // translated 
  permissionDenied: "許可が拒否されました", // translated 
  permissionNotRequested: "許可が要求されていない", // translated 
  enabled: "有効", // translated 
  disabled: "無効", // translated 
};


export default my_profile;
